import { v4 as uuidv4 } from 'uuid';

export function generateTraceId() {
  return uuidv4();
}

export function withTrace(action, originAction = null) {
  const traceId = action.meta?.traceId || generateTraceId();

  return {
    ...action,
    meta: {
      ...action.meta,
      traceId,
      originAction: originAction || action.type,
      timestamp: Date.now(),
    },
  };
}

export function logAction(action, context = {}) {
  if (import.meta.env.DEV) {
    console.log('[TRACE]', {
      traceId: action.meta?.traceId,
      type: action.type,
      origin: action.meta?.originAction,
      timestamp: action.meta?.timestamp,
      duration: context.duration,
      ...context,
    });
  }
}

export function logUserAction(traceId, action, context = {}) {
  if (import.meta.env.DEV) {
    console.log('[USER ACTION]', {
      traceId,
      action,
      timestamp: Date.now(),
      ...context,
    });
  }
}
